import React from 'react';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import { Route, Switch } from 'react-router-dom';
import MyUtil from '../../functions/MyUtil';
import '../css/Warehouse.css';
import FormAddDirectDiscount from './FormAddDirectDiscount';
import FormAddRecurringDiscount from './FormAddRecurringDiscount';
import ListDirectDiscount from './ListDirectDiscount';

const DirectDiscount = (props) => {
  const { match } = props;
  return (
    <Switch>
      {MyUtil.hasPermission(match.url, 'view') && (
        <Route
          exact
          path={`${match.url}`}
          component={() => <ListDirectDiscount match_parent={match} />}
        />
      )}

      {MyUtil.hasPermission(match.url, 'add') && (
        <Route
          path={`${match.url}/add-recurring`}
          component={FormAddRecurringDiscount}
        />
      )}
      {MyUtil.hasPermission(match.url, 'update') && (
        <Route
          path={`${match.url}/edit-recurring/:discountId`}
          component={FormAddRecurringDiscount}
        />
      )}

      {MyUtil.hasPermission(match.url, 'add') && (
        <Route path={`${match.url}/add`} component={FormAddDirectDiscount} />
      )}
      {MyUtil.hasPermission(match.url, 'update') && (
        <Route
          path={`${match.url}/edit/:discountId`}
          component={FormAddDirectDiscount}
        />
      )}
    </Switch>
  );
};

export default DirectDiscount;
